import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFormField } from "../Slices/formSlice";

const GeneratedSkills = () => {


  const state = useSelector(state => state.form)
  const formData = useSelector((state) => state.form);

  const dispatch = useDispatch()

  const handleUpdate = (skill, checked) => {

    if (checked) {

      dispatch(updateFormField({ field: 'skillsRequiredForJob', value: [...state.skillsRequiredForJob, skill.trim()] }))

    } else {

      let filt = state.skillsRequiredForJob.filter((i) => i != skill.trim())

      dispatch(updateFormField({ field: 'skillsRequiredForJob', value: filt }))
    }

  }


  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6">
      <div className="canLisTxtStyl mb-4">
        <p>Skill Group Recommendations</p>
      </div>
{console.log('generatedSkills-->', formData.generatedSkillsArray)}
      {formData.generatedSkillsArray?.map((group, index) => (
        <div key={index} className="border rounded-xl shadow-md p-4 bg-white">
          <div className="canLisTxtStyl mb-4">
            <p>{group.group_name}</p>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <div className="canLisTxtStyl mb-2">
                <p className="text-green-700 font-medium mb-2 job_size1">
                  ✅ Recommended Skills
                </p>
              </div>
              <ul className="list-disc list-inside space-y-1 text-gray-800 job_size">
                {group.recommended_skills.map((skill, i) => (
                  <li key={i}>
                    <input type="checkbox"
                      checked={state.skillsRequiredForJob.includes(skill.trim())}
                      onChange={(e) => handleUpdate(skill, e.target.checked)}
                    />
                    <span className="ml-2 " style={{ marginLeft: '6px' }}>{skill}

                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="canLisTxtStyl mb-2 job_size1">
                <p className="job_size1">⚠️ Unrecommended Skills</p>
              </div>
              <ul className="list-disc list-inside space-y-1 text-gray-600 job_size">
                {group.unrecommended_skills.map((skill, i) => (
                  <li key={i}>

                    <input type="checkbox"
                      checked={state.skillsRequiredForJob.includes(skill.trim())}
                      onChange={(e) => handleUpdate(skill, e.target.checked)}
                    />
                    <span className="ml-2 " style={{ marginLeft: '6px' }}>
                      {skill}

                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))
      }
    </div >
  );
};

export default GeneratedSkills;
